module.exports = __webpack_public_path__ + "static/media/product_category_25.5692d869.png";